export const SEND_RECEIPT_EMAIL = `
mutation($input: EmailBillReceiptInput){
   sendBillReceipt(input:$input)
}
`;
